<template>
    <div v-if="isShow" class="auth-header-con">
        <div class="header-content">
            <div class="left-view" v-if="userInfo.UserID">
                <span>{{userInfo.UserName || userInfo.Phone}}</span>
                <span @click="_logOut">退出登录</span>
            </div>
            <div class="left-view" v-else>
                <span @click="_goLogin">您好，请登录</span>
                <span @click="_goRegister(1)">企业注册</span>
                <span @click="_goRegister(0)">个人注册</span>
            </div>
            <div class="right-view">
                <a :href="dggjDown" target="_blank">下载大国工匠</a>
            </div>
        </div>
    </div>
</template>

<script>
    import {MessageBox} from 'element-ui'
    import {CheckLibs,UserService,AppName,AppClientDownPath} from '@digital-supply-chain/module'
    import {UserEnum} from '@digital-supply-chain/module/dist/enum/user'
    import {DomainService} from '@/libs'
    import Event, {EventEnum} from '@/EventEmeitter'

    export default{
        data() {
            return {
                isShow: !CheckLibs.isClient() && !CheckLibs.isInIframe(),
                userInfo: UserService.user(),
                dggjDown: AppClientDownPath[AppName.Dggj],
            }
        },
        methods: {
            _goRegister(type) {
                window.open(`${DomainService.EngineerCommon}/#/register/${type}?redirect=${encodeURIComponent(location.href)}&active_key=register`);
            },
            _goLogin() {
                Event.emit(EventEnum.LOGIN_OPEN);
            },
            _logOut() {
                MessageBox.confirm('确定退出登录吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    window.localStorage.removeItem(UserEnum.USERINFO);
                    window.location.reload(true);
                });
            }
        },
    }
</script>

<style lang="less" scoped>
    .auth-header-con{
        height: 100%;
        height: 36px;
        position: sticky;
        top: 0;
        z-index: 999;
        background-color: #333333;
    }
    .header-content{
        width: 1200px;
        height: 100%;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .left-view{
        font-size: 12px;
        color: #ccc;
        span{
            cursor: pointer;
            padding: 0 14px;
            border-left: 1px solid #595959;
        }
        span:first-child{
            border: 0 none;
        }
        span:hover{
            color: #ffffff;
        }
    }
    .right-view{
        a{
            font-size: 12px;
            color: #ccc;
            text-decoration: none;
        }
        a:hover{
            color: #ffffff;
        }
    }
</style>